import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '../services/translate.service';

@Pipe({
  name: 'proposalTask',
})
export class ProposalTaskPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(value: unknown, ...args: unknown[]): unknown {
    return this.translate.s('task_' + value, 'pipe');
  }
}
